import React from 'react';
import { Box } from '@mui/material';

interface KPICardProps {
  title: string;
  value?: number | string;
  subtitle?: string;
  icon?: React.ReactNode;
  midiValue?: number | string;
  soirValue?: number | string;
  midiLabel?: string;
  soirLabel?: string;
  comparison?: string;
}

export default function KPICard({
  title,
  value,
  subtitle,
  icon,
  midiValue,
  soirValue,
  midiLabel = 'Midi',
  soirLabel = 'Soir',
  comparison,
}: KPICardProps) {
  const format = (v?: number | string) => {
    if (typeof v === 'number') return v.toLocaleString('fr-FR');
    return v ?? '';
  };

  return (
    <Box className={`rounded-xl p-6 border transition`} sx={{ borderColor: "divider", backgroundColor: "background.paper", color:"text.primary" }}>
      <div className='flex justify-between items-start mb-4'>
        <span className={`text-sm font-semibold `}>{title}</span>
        {icon && <span className='text'>{icon}</span>}
      </div>
      
      <div className='flex flex-col gap-3'>
        {midiValue !== undefined && soirValue !== undefined ? (
          <div className='flex justify-between items-end gap-4'>
              <div className='flex flex-col'>
                <span className={`text-xs mb-1 `}>{midiLabel}</span>
                <span className={`text-3xl font-bold `}>{format(midiValue)}</span>
              </div>
            <div className={`flex-1 h-px `}></div>
            <div className='flex flex-col text-right'>
              <span className={`text-xs mb-1 `}>{soirLabel}</span>
              <span className={`text-3xl font-bold `}>{format(soirValue)}</span>
            </div>
          </div>
        ) : (
          <>
            <span className={`text-4xl font-bold tracking-tight `}>{format(value)}</span>
            {subtitle && <span className={`text-sm `}>{subtitle}</span>}
          </>
        )}
      </div>

      {comparison && (
        <div className={`mt-3 pt-3 border-t text-xs `}>
          {comparison}
        </div>
      )}
    </Box>
  );
}
